import { useEffect, useState } from "react";
import Skeleton from "@mui/material/Skeleton";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { TableCard } from "../../../../component/table/table-layout";
import { CustomDropdown } from "../../../../component/ui/dropdown/CustomDropdown";
import { CustomDropdownButton } from "../../../../component/ui/dropdown/CustomDropdownButton";
import { CustomDropdownMenu } from "../../../../component/ui/dropdown/CustomDropdownMenu";
import { CustomDropdownMenuList } from "../../../../component/ui/dropdown/CustomDropdownMenuList";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  KPI,
  TitleHeading,
} from "../../../../component/ui/layout";
import {
  FeildWraper,
  FormCheckbox,
} from "../../../../component/form/form-layout";
import moment from "moment";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import {
  AlertTriangle,
  CircleDollarSign,
  DollarSign,
  History,
  Percent,
  RotateCcw,
  ShieldCheck,
  ShieldX,
  TrendingUp,
  UserMinus,
  UserX,
} from "lucide-react";
import RefundList from "./list";

export default function OrgRefundOverview() {
  const apiCall = useApiCall();
  const [dashboardData, setDashboardData] = useState({});
  const [isDashboardApiLoaded, setIsDashboardApiLoaded] = useState(false);
  const [isTrendLoad, setIsTrendLoad] = useState(false);
  const [monthlyTrend, setMonthlyTrend] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(
    moment(new Date()).format("YYYY-MM")
  );
  const [activeChart, setActiveChart] = useState("Monthly Location Breakdown");
  // const [selectedMonth, setSelectedMonth] = useState(moment(new Date()).format("YYYY-MM"));
  const [allTime, setAllTime] = useState(false);
  const [allTimeLoader, setAllTimeLoader] = useState(false);
  const [kpiData, setKpiData] = useState({});
  const [apiData, setApiData] = useState({});

  const getDashboardData = async () => {
    setIsDashboardApiLoaded(false);
    try {
      const resp = await apiCall({ method: "get", url: `reports/dashboard` });
      setDashboardData(resp);
      // setKpiData(allTime ? (resp?.data) : (resp?.monthly))
      setKpiData(resp?.data);
      setApiData(resp?.data?.qa_status_report);
      setAllTimeLoader(true);
      setIsDashboardApiLoaded(true);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  // const getMonthlyTrend = async () => {
  //   try {
  //     const resp = await apiCall({ method: "get", url: `get-monthly-water-tanker-trends?type=chart` });
  //     setMonthlyTrend(resp.data);
  //     setIsTrendLoad(true);
  //   } catch (error) {
  //     console.log("Err", error)
  //   }
  // }

  // useEffect(() => {
  //   getMonthlyTrend();
  // }, []);

  useEffect(() => {
    getDashboardData();
  }, [selectedMonth]);

  const parseAmount = (value = "PKR 0.00") =>
    Number(value.replace("PKR ", "").replaceAll(",", ""));

  const rawData = monthlyTrend; // API response

  const dynamicKeys = Object.keys(rawData?.[0] || {}).filter(
    (key) => key !== "month"
  );

  const monthlyChart = {
    chart: { type: "line", backgroundColor: "transparent", height: 400 },
    title: { text: "" },
    xAxis: {
      categories: monthlyTrend?.map((list) => list.month),
      lineColor: "#E5E7EB",
      labels: { style: { color: "#6B7280" } },
    },
    yAxis: {
      title: { text: "Monthly" },
      gridLineColor: "#F3F4F6",
      labels: { style: { color: "#6B7280" } },
    },
    legend: { align: "right", verticalAlign: "top" },
    // series: [
    //   {
    //     name: "Cost",
    //     data: monthlyTrend?.map((d) => Number(d.total_cost?.replaceAll("PKR ", "")?.replaceAll(",", ""))),
    //   }
    // ],
    // series: monthlyTrend?.map((d) =>
    //   Object.entries(d)?.map(([key, val]) => {
    //     console.log("key", key)
    //     if(key != "month"){
    //       return({
    //         name: key,
    //         data: val?.replaceAll("PKR ", "")?.replaceAll(",", ""),
    //       })
    //     }
    //   })
    // ),
    series: dynamicKeys.map((key) => ({
      name: key,
      data: rawData.map((item) => parseAmount(item[key])),
    })),
    credits: { enabled: false },
  };

  // const serviceOptions = {
  //   chart: {
  //     type: "column",
  //     animation: {
  //       duration: 600,
  //       easing: "easeOutBounce"
  //     }
  //   },
  //   title: "none",
  //   credits: { enabled: false },
  //   xAxis: {
  //     categories: dashboardData?.location_breakdown?.map(item => item.location),
  //     title: "none"
  //   },
  //   yAxis: {
  //     min: 0,
  //     title: { text: activeChart }
  //   },
  //   tooltip: {
  //     shared: true,
  //   },
  //   plotOptions: {
  //     series: {
  //       grouping: true   // <— REQUIRED when you have 2 bars per category
  //     },
  //     column: {
  //       pointWidth: 45,
  //       pointPadding: 0.05,
  //       groupPadding: 0.2,
  //     }
  //   },
  //   series: activeChart == "Cost" ? [
  //     {
  //       name: "Amount",
  //       color: "#50E3C2",
  //       data: dashboardData?.location_breakdown?.map(item =>
  //         Number(item?.amount?.replaceAll("PKR ", "")?.replaceAll(",", ""))
  //       )
  //     }
  //   ] : [
  //     {
  //       name: "Liter",
  //       color: "#4A90E2",
  //       data: dashboardData?.location_breakdown?.map(item =>
  //         Number(item?.liters)
  //       )
  //     }
  //   ],
  //   legend: { enabled: false }, // single series, legend not needed
  // };

  // const serviceOptions = {
  //   chart: {
  //     type: "column",
  //     animation: {
  //       duration: 600,
  //       easing: "easeOutBounce"
  //     }
  //   },
  //   title: "none",
  //   credits: { enabled: false },
  //   xAxis: {
  //     categories: dashboardData?.location_breakdown?.map(item => item.location),
  //     title: "none"
  //   },
  //   yAxis: {
  //     min: 0,
  //     title: { text: activeChart }
  //   },
  //   tooltip: {
  //     formatter: function () {
  //       const item = dashboardData?.location_breakdown?.[this.point.index];

  //       return `
  //         <b>${item?.location}</b><br/>
  //         ${item?.amount} (${item?.gallons} GL)
  //       `;
  //     }
  //   },
  //   // tooltip: {
  //   //   shared: true,
  //   // },
  //   plotOptions: {
  //     series: {
  //       grouping: true   // <— REQUIRED when you have 2 bars per category
  //     },
  //     column: {
  //       pointWidth: 45,
  //       pointPadding: 0.05,
  //       groupPadding: 0.2,
  //     }
  //   },
  //   series: [
  //     {
  //       name: "Amount",
  //       color: "#4A90E2",
  //       data: dashboardData?.location_breakdown?.map(item =>
  //         Number(item.amount?.replaceAll("PKR ", "")?.replaceAll(",", ""))
  //       )
  //     }
  //   ],
  //   legend: { enabled: false }, // single series, legend not needed
  // };

  // const pieOptions = {
  //   chart: {
  //     type: "pie"
  //   },
  //   title: "none",
  //   credits: { enabled: false },
  //   // tooltip: {
  //   //   pointFormat: "{series.name}: <b>{point.count}</b><br/>Percentage: <b>{point.percentage:.1f}%</b>"
  //   // },
  //   accessibility: {
  //     point: {
  //       valueSuffix: "%"
  //     }
  //   },
  //   plotOptions: {
  //     pie: {
  //       allowPointSelect: true,
  //       cursor: "pointer",
  //       dataLabels: {
  //         enabled: true,
  //         format: "<b>{point.name}</b>: {point.percentage:.1f}% ({point.count})"
  //       }
  //     },
  //   },
  //   series: [
  //     {
  //       name: "Invoices",
  //       colorByPoint: true,
  //       data: Object.entries(dashboardData?.invoices_status || {})?.map(([key, val], i) => ({
  //         // count: parseFloat(val),
  //         name: key,
  //         y: parseFloat(val) // Or use dept.count if you want raw counts
  //       }))
  //     }
  //   ],
  //   legend: { enabled: false }, // single series, legend not needed
  // };

  // const changeAllTime = (e) => {
  //   setAllTimeLoader(false)
  //   setAllTime(e);
  //   setKpiData(e ? (dashboardData?.totals) : (dashboardData?.monthly))

  //   setTimeout(() => {
  //     setAllTimeLoader(true)
  //   }, 250);
  // }

  // console.log(kpiData)


  const formatToUSDShort = (amount) => {
    if (!amount) return "";

    // Remove $ and commas
    const num = Number(
      amount.toString().replace(/[^0-9.-]+/g, "")
    );

    if (isNaN(num)) return "";

    if (num >= 1_000_000_000) {
      return `$${(num / 1_000_000_000).toFixed(2)}B`;
    }

    if (num >= 1_000_000) {
      return `$${(num / 1_000_000).toFixed(2)}M`;
    }

    if (num >= 1_000) {
      return `$${(num / 1_000).toFixed(2)}K`;
    }

    return `$${num.toLocaleString("en-US")}`;
  };


  return (
    <>
      <div className="pt-[20px] overflow-hidden">
        <div className="w-full h-full overflow-hidden flex flex-col gap-[20px]">
          {/* Header */}
          <div className="flex items-center justify-between">
            <TitleHeading>Refunds Overview</TitleHeading>
            {/* <div className="">
              <FeildWraper className={"!w-full !py-0"}>
                <input type="month" className="w-[200px]" max={moment(new Date()).format("YYYY-MM")} value={selectedMonth} onChange={(e) => { setSelectedMonth(e.target.value) }} />
              </FeildWraper>
            </div> */}
            <div className="flex gap-3 flex-shrink-0 w-fit items-center justify-end">
              {/* <FeildWraper className="!w-fit !flex-[0_0_auto] min-w-0 !px-0 !py-0">
                <FormCheckbox
                  label="All Time"
                  name="all_time"
                  checked={allTime}
                  onChange={(e) => changeAllTime(e.target.checked)}
                  className={'!w-[100px]'}
                />
              </FeildWraper>
              <FeildWraper className={"!w-fit !flex-[0_0_auto] !pl-0 !py-0"}>
                <input type="month" disabled={allTime} className="!w-[180px]" max={moment(new Date()).format("YYYY-MM")} value={selectedMonth} onChange={(e) => { setSelectedMonth(e.target.value) }} />
              </FeildWraper> */}
            </div>
          </div>

          {/* KPI Row */}
          <TableCard className={"!p-[15px] !pr-[7px] h-full overflow-hidden"}>
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
              {isDashboardApiLoaded ? (
                <>
                  {/* <KPI
                    icon={Gauge}
                    label={"Total Tankers"}
                    value={kpiData?.total_tankers}
                    // sublabel={(allTime) ? `All-time Entries` : `${kpiData?.month} Entries`}
                    sublabel="This Month"

                  />

                  <KPI
                    icon={Droplets}
                    label={"Total Gallons"}
                    value={kpiData?.total_gallons}
                    sublabel={(allTime) ? `All-time Entries` : `${kpiData?.month} Entries`}
                  />

                  <KPI
                    icon={Wallet}
                    label={"Total Tanker Cost"}
                    value={kpiData?.total_tanker_cost}
                    sublabel={(allTime) ? `All-time Entries` : `${kpiData?.month} Entries`}
                  />

                  <KPI
                    icon={BarChart3}
                    label={"Total Tanker Cost Paid"}
                    value={kpiData?.total_tanker_cost_paid}
                    sublabel={(allTime) ? `All-time Entries` : `${kpiData?.month} Entries`}
                  />

                  <KPI
                    icon={Fuel}
                    label={"Total Tanker Cost Unpaid"}
                    value={kpiData?.total_tanker_cost_unpaid}
                    sublabel={(allTime) ? `All-time Entries` : `${kpiData?.month} Entries`}
                    // sublabel={"Monthly Consumption (Liters)"}
                  /> */}

                  {/* <KPI
                    icon={Calendar}
                    label={"Fuel Cost"}
                    value={dashboardData?.current_month?.cost}
                    // sublabel={`${dashboardData?.current_month?.month}`}
                    sublabel={"Monthly Expenditure (Pkr)"}
                  /> */}

                  <KPI
                    icon={History}
                    label={"Total Orders"}
                    value={kpiData?.total_orders}
                    // sublabel={(allTime) ? `All-time Entries` : `${kpiData?.month} Entries`}
                    sublabel="All Time"
                  />

                  <KPI
                    icon={CircleDollarSign}
                    label="Total Revenue"
                    value={formatToUSDShort(kpiData?.total_revenue)}
                    sublabel="All Time"
                  />

                  <KPI
                    icon={RotateCcw}
                    label="Total Refunds"
                    value={kpiData?.total_refund}
                    sublabel="All Time"
                  />

                  <KPI
                    icon={DollarSign}
                    label="Refunded Amount"
                    value={kpiData?.total_refunded_amount}
                    sublabel="All Time"
                  />

                  <KPI
                    icon={Percent}
                    label="Revenue Refund Rate"
                    value={kpiData?.revenue_refund_rate}
                    sublabel="All Time"
                  />

                  <KPI
                    icon={UserX}
                    label="Sales Blame Count"
                    value={kpiData?.sales_blame_count}
                    sublabel="All Time"
                  />

                  <KPI
                    icon={CircleDollarSign}
                    label="Sales Blame Amount"
                    value={kpiData?.sales_blame_amount}
                    sublabel="All Time"
                  />

                  <KPI
                    icon={UserMinus}
                    label="Customer Blame Count"
                    value={kpiData?.customer_blame_count}
                    sublabel="All Time"
                  />

                  <KPI
                    icon={DollarSign}
                    label="Customer Blame Amount"
                    value={kpiData?.customer_blame_amount}
                    sublabel="All Time"
                  />

                  <KPI
                    icon={AlertTriangle}
                    label="Total Chargebacks"
                    value={kpiData?.total_charge_backs}
                    sublabel="All Time"
                  />

                  <KPI
                    icon={ShieldCheck}
                    label="Chargebacks Won"
                    value={kpiData?.cb_won}
                    sublabel="All Time"
                  />

                  <KPI
                    icon={ShieldX}
                    label="Chargebacks Lost"
                    value={kpiData?.cb_lost}
                    sublabel="All Time"
                  />

                  <KPI
                    icon={TrendingUp}
                    label="Chargeback Win Rate"
                    value={kpiData?.cb_win_rate}
                    sublabel="All Time"
                  />
                </>
              ) : (
                Array.from({ length: 5 }).map((_, index) => (
                  <div
                    key={index}
                    className="bg-white shadow rounded-xl p-4 animate-pulse"
                  >
                    {/* Top row: label + icon */}
                    <div className="flex items-center justify-between mb-2">
                      <Skeleton variant="text" width={80} height={16} />
                      <Skeleton variant="circular" width={20} height={20} />
                    </div>
                    {/* Value row */}
                    <div className="flex items-center justify-between gap-2 mb-1 mt-2 py-[12px]">
                      <Skeleton variant="text" width={60} height={32} />
                      <Skeleton variant="rounded" width={40} height={20} />
                    </div>
                    {/* Sublabel */}
                    <Skeleton variant="text" width={80} height={12} />
                  </div>
                ))
              )}
            </div>

            <div className="col-span-1 md:col-span-5  mt-[20px] p-5 min-h-[400px] border border-[#E1E4EA] max-h-[600px] lg:max-h-[700px] shadow rounded-[10px] overflow-hidden">
              <RefundList data={apiData} isLoading={isDashboardApiLoaded} />
            </div>

            {/* <div className="grid grid-cols-1 md:grid-cols-6 gap-6 mt-6">
             
              <Card className="col-span-4 min-h-[500px]">
                <CardHeader className="flex items-center justify-between">
                  <CardTitle className="flex items-center gap-2">
                    <TrendingUp className="h-5 w-5" /> Monthly Trends
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  {
                    isTrendLoad ? (
                      <HighchartsReact highcharts={Highcharts} options={monthlyChart} />
                    ) : (
                      <InnerLoader />
                    )
                  }
                </CardContent>
              </Card>

              <Card className="col-span-2 min-h-[500px]">
                <CardHeader className="flex items-center justify-between">
                  <CardTitle className="flex items-center gap-2">
                    <BarChart3 className="h-5 w-5" />
                    
                    <CustomDropdown
                      position="bottom-right"
                      className="myDropdown"
                    >
                      <CustomDropdownButton arrow={true} className="btnClass">
                        <h3 className="!text-[16px]">{activeChart}</h3>
                      </CustomDropdownButton>

                      <CustomDropdownMenu className="w-full">
                        {activeChart != "Monthly Location Breakdown" && (
                          <CustomDropdownMenuList
                            onClick={() => {
                              setActiveChart("Monthly Location Breakdown");
                            }}
                          >
                            <div
                              className={
                                "d-flex whitespace-normal align-items-center gap-1"
                              }
                            >
                              Monthly Location Breakdown
                            </div>
                          </CustomDropdownMenuList>
                        )}
                        {activeChart != "Monthly Invoice Breakdown" && (
                          <CustomDropdownMenuList
                            onClick={() => {
                              setActiveChart("Monthly Invoice Breakdown");
                            }}
                          >
                            <div
                              className={
                                "d-flex whitespace-normal align-items-center gap-1"
                              }
                            >
                              Monthly Invoice Breakdown
                            </div>
                          </CustomDropdownMenuList>
                        )}
                      </CustomDropdownMenu>
                    </CustomDropdown>
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  {
                    isDashboardApiLoaded ? (
                      activeChart == "Monthly Location Breakdown" ?
                        <HighchartsReact highcharts={Highcharts} options={serviceOptions} />
                        :
                        <HighchartsReact highcharts={Highcharts} options={pieOptions} />                      
                    ) : (
                      <InnerLoader />
                    )
                  }
                </CardContent>
              </Card>
            </div> */}
          </TableCard>
        </div>
      </div>
    </>
  );
}
